import CasinoItem from "./CasinoItem";
import styles from './scss/CasinoItems.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {getCasinos} from "../state-management/slices/casinoListSlice";
import {CasinoItemsInterface, MainStore} from "../types";
import SkeletonLoader from "./SkeletonLoader";
import React, {useEffect, useState} from "react";
import If from "./BaseComponent/If";

type CasinoItemsProps = {
    multiKey?: string;
}

const CasinoItems = ({multiKey}: CasinoItemsProps) => {
    const dispatch = useDispatch();
    const {maxPage, currentPage} = useSelector((state: MainStore) => state.casinoListSlice);
    const {filteredData, initialLoad, generalTexts} = useSelector((state: MainStore) => state.casinoListSlice);
    let partitions = multiKey ? (filteredData as CasinoItemsInterface[]).filter(b => Number(b.bonusTypeId) === Number(multiKey.split('_').pop())) : filteredData;
    const [renderPartitions, setRenderPartitions] = useState(partitions);
    const {
        layoutSettings: {layout},
        behaviorSettings: {pagination},
        stateSettings: {payload},
    } = useSelector((state: MainStore) => state.componentsConfig);
    const isTableView = layout === 'table';

    const loadMore = () => {
        dispatch(getCasinos({perPage: payload.perPage}));
    }
    useEffect(() => {
        setRenderPartitions(partitions);
    }, [partitions])


    useEffect(() => {
        if (initialLoad) {
            document.querySelector('.loader-wrapper')?.remove();
        }
    }, [initialLoad]);
    return (
        <>
            <If condition={isTableView}>
                <div className="loader-wrapper">
                    {renderPartitions.map(item =>
                        <SkeletonLoader key={item.id}/>
                    )}
                </div>
            </If>
            <If condition={initialLoad}>
                <>
                    <ul className={` ${styles.list} ${!isTableView ? `card-grid ${styles['card-grid']}` : ''}`}>
                        {renderPartitions.map((item: any, index: number): JSX.Element => {
                                return (
                                    <CasinoItem
                                        index={index + 1}
                                        layout={layout}
                                        customClass={!isTableView ? 'card-desktop' : ''}
                                        data={item}
                                        key={item.id}
                                        keyProp={item.id}
                                    />
                                )
                            }
                        )}
                    </ul>
                    {maxPage > currentPage && pagination && filteredData.length &&
                        <button onClick={loadMore} className="prefix-btn m-auto">{generalTexts.showMore}</button>
                    }
                </>
            </If>
        </>
    )

}

export default CasinoItems;
